module.exports = __webpack_public_path__ + "img/descomplica_exercicios_logo.04dbc8b5.svg";